import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../config/assetApiConfig';

// Create Asset Category
export const createAssetCategory = createAsyncThunk(
    'assetCategory/create',
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await assetServiceApiInstance.post('/asset-categories', data);
        return response.data;
      } catch (error: any) {
        const errorPayload = {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
        };
        return rejectWithValue(errorPayload);
      }
    }
  );  

// Fetch Asset Category by ID
export const fetchAssetCategoryById = createAsyncThunk(
  'assetCategory/fetchById',
  async (categoryId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-categories/${categoryId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset category');
    }
  }
);

// Fetch All Asset Categories
export const fetchAllAssetCategories = createAsyncThunk(
  'assetCategory/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get('/asset-categories');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset categories');
    }
  }
);

// Update Asset Category
export const updateAssetCategory = createAsyncThunk(
  'assetCategory/update',
  async ({ categoryId, ...data }: any & { categoryId: number }, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.put(`/asset-categories/${categoryId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update asset category');
    }
  }
);

// Delete Asset Category
export const deleteAssetCategory = createAsyncThunk(
  'assetCategory/delete',
  async (categoryId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.delete(`/asset-categories/${categoryId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete asset category');
    }
  }
);
